module.exports = __webpack_public_path__ + "static/media/nit.e20ae1aa.svg";